module.exports = __webpack_public_path__ + "static/maurezhi-6aea9491d6c553f842339054f15c9738.png";